<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <d-col col class="mb-4 text-center text-sm-left mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Revistas</span>
        <h3 class="page-title d-inline">Editar</h3>
        <router-link class="float-right text-white btn btn-success " :to="{ name: 'admin-magazine-new' }">Nova revista</router-link>
      </d-col>
    </d-row>
    <magazine-page/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import MagazinePage from '../components/MagazinePage.vue';
import { _LOAD_MODEL_ } from '../components/MagazineModel';

export default {
  name: 'magazine-edit',
  components: {
    MagazinePage,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getMagazine',
    ]),
  },
  mounted() {
    if (this.$route.params.magazineId) {
      this.getMagazine(this.$route.params.magazineId)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
        });
    }
  },
};
</script>

